"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
/**
 * Screen breakpoints. Must match the variables file.
 */
exports.breakpoints = {
    // Extra small screen / phone / iphone X
    sm: 768,
    // Medium screen / desktop / tablet landscape
    md: 1024,
    // Large screen / wide desktop
    lg: 1200,
    // Xtra-Large screen / ultra wide desktop
    xl: 1441
};
//# sourceMappingURL=screenBreakpoints.js.map